import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { ForWhomSection } from './components/ForWhomSection';
import { FAQSection } from './components/FAQSection';
import { PricingCTA } from './components/PricingCTA';
export function App() {
  return <main className="w-full min-h-screen bg-[#FFF8F0]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MechanismSection data-id="element-3" />
      <WhatYouGetSection data-id="element-4" />
      <ForWhomSection data-id="element-5" />
      <FAQSection data-id="element-6" />
      <PricingCTA data-id="element-7" />

      {/* Simple footer */}
      <footer className="w-full bg-[#3D2B1F] px-4 py-8 text-center" data-id="element-8">
        <p className="text-[#C4B5A6] text-sm" data-id="element-9">
          © 2026 Primeros Auxilios Emocionales. Todos los derechos reservados.
        </p>
        <p className="text-[#8B7565] text-xs mt-2" data-id="element-10">
          Este producto es educativo y no reemplaza la terapia profesional.
        </p>
      </footer>
    </main>;
}